import { SelectItem } from 'primeng/api';
import { TransactionType } from '../enums';

export class TransactionTypeLookup {
    static getLookup(): SelectItem[] {
        return [
            { label: 'Increase Balance', value: TransactionType.IncreaseBalance },
            { label: 'Decrease Balance', value: TransactionType.DecreaseBalance }];
    }

    static getTitleById(id) {
        return this.getLookup().find(f => f.value === id)?.label || '';
    }

    static getById(id) {
        return this.getLookup().find(f => f.value === id) || null;
    }
}
